export function basename(path: string) {
  return path.split("/").pop();
}

export function dirname(path: string) {
  return path.substring(0, path.lastIndexOf("/") + 1);
}

export function blockMaker(path: string) {
  const folderList = path.split("/");
  const isBlockPath = folderList[0] === "block";
  if (isBlockPath) {
    [folderList[1], folderList[0]] = [folderList[0], folderList[1]];
    return folderList.join("/");
  }
  return path;
}

// 处理url上query参数的对象
export function getUrlQueryParams(url: string) {
  const urlObj = new URL(url);
  const query = urlObj.searchParams;
  return Object.fromEntries(query);
}
